import { WCS } from './../../week-utils';
import styled, { css } from 'styled-components';

export const EventMenuSC = styled.div<{
  menuWidth: number;
  verticalPosition: 'down' | 'up';
}>`
  position: fixed;
  z-index: 99997;
  background: transparent;
  display: flex;
  width: ${({ menuWidth }) => menuWidth}px;
  max-height: calc(100vh - ${WCS.topNavOffset + WCS.bottomNavOffset}px);
  transition: all 0.05s;

  ${({ verticalPosition }) => {
    const hp = 'left';
    const vp = verticalPosition === 'up' ? 'bottom' : 'top';
    return css`
      &.week-calendar-menu-enter {
        opacity: 0;
        transform: scale(0) translateX(-20px);
        transform-origin: ${vp} ${hp};
      }

      &.week-calendar-menu-enter-active {
        opacity: 1;
        transition: all 300ms;
        transform: scale(1) translateX(0);
        transform-origin: ${vp} ${hp};
      }

      &.week-calendar-menu-exit {
        opacity: 1;
        transform-origin: ${vp} ${hp};
        transform: scale(1) translateX(0);
      }

      &.week-calendar-menu-exit-active {
        opacity: 0;
        transition: all 300ms;
        transform: scale(0) translateX(-20px);
        transform-origin: ${vp} ${hp};
      }
    `;
  }}
`;
